import React, { useState, useContext, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import Spinner from "react-bootstrap/Spinner";
import Button from "react-bootstrap/Button";
import PageNotFound from "../pages/PageNotFound";
import Placeholder from 'react-bootstrap/Placeholder';
import { Card } from "react-bootstrap";
import AuthContext from "../store/auth-context";
import Login from "../components/Login";
import Wrapper from "../Helpers/Wrapper";


const MyFrame = (props) => {
  const authCtx = useContext(AuthContext);
  const [iAmDesktop, setiAmDesktop] = useState(true);
  const [showSpinner, setShowSpinner] = useState(true);
  const [redTime, setRedTime] = useState('3')


  useEffect(() => {
    // console.log(`In useEffect 1 reloading page`);
      const userAgent = navigator.userAgent.toLowerCase();
      // console.log(`User agent: ${userAgent}`);
      const navPlatform = navigator.platform;
      // console.log(`Platform: ${navPlatform}`);
      // let isMobile = /iphone|ipad|ipod|android|blackberry|windows phone/g.test(userAgent);
      // let isTablet = /(ipad|tablet|playbook|silk)|(android(?!.*mobile))/g.test(userAgent);

      let isTablet = false;

      if (('ontouchstart' in window) || (navigator.MaxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0)) {
        // console.log("This is an iOS device.");
        isTablet = true
      } else {
          // console.log("This is not an iOS device!");
          isTablet = false
      }

      if (isTablet) {
        setiAmDesktop(false)
        if(!props.frameContent.includes(".php")){
          setTimeout(() => {
            window.open(props.frameContent, '_blank', 'noreferrer');
          }, redTime*1000);
        }
      } 

    // console.log(`props ${JSON.stringify(props)}`);
    // console.log(`props.frameContent ${props.frameContent}`);

  }, [props.frameContent]);

  useEffect(() => {}, [authCtx.isLoggedIn])

  const hideSpinner = () => {
    setShowSpinner(false);
  };

  const setHeight = () => {
    // console.log('MyFrame', props.frameContent);
    if (props.frameContent === "") {
      return (
        <div>
          <PageNotFound />
        </div>
      );
    } else {
      return (
        <Container>
          <Row className="p-2 justify-content-md-center">
                {props.frameContent.includes(".php") ? 
                  <>
                    {authCtx.isLoggedIn ? (   
                      <iframe
                        id="dynamic-frame"
                        type="application/pdf"
                        src={`${props.frameContent}#view=fitH,view=fitV`}
                        height="1050px"
                        width="100%"
                        title="dynamic content"
                        onLoad={hideSpinner}
                      ></iframe>
                      ) : (
                      <div style={{textAlign: "center"}}>
                        <h3 >
                          Please <Login handleLogin={authCtx.onLogin} variant="success"/> to manage events!
                        </h3>
                      </div>
                    )}
                  </> : 
                  <>
                    <>
                    {iAmDesktop ?  
                      <>
                        {showSpinner ? (
                          <div>
                            <Card.Title>Please wait, loading...</Card.Title>
                            <Placeholder as={Card.Text} animation="glow">
                              <Placeholder xs={7} /> <Placeholder xs={4} /> <Placeholder xs={4} />{' '}
                              <Placeholder xs={6} /> <Placeholder xs={8} />
                            </Placeholder>
                          </div>
                        ) : null}
                          <iframe
                            id="dynamic-frame"
                            type="application/pdf"
                            // src={`https://docs.google.com/gview?url=${props.frameContent}&embedded=true`}
                            // src={`https://https://drive.google.com/viewerng/viewer?embedded=true&url=${props.frameContent}&embedded=true`}
                            src={props.frameContent}
                            height="1050px"
                            width="100% !important"
                            title="dynamic content"
                            onLoad={hideSpinner}
                          ></iframe>
                        </>
                    : 
                      (
                        <Card className="text-center">
                          {/* <Card.Header as="h5"></Card.Header> */}
                          <Card.Body>
                            <Card.Title>Unfortunately, PDF viewing is not supported on mobile devices.</Card.Title>
                            <Card.Text>
                              You should be automatically redirected to view PDF in {redTime} seconds. If you are not redirected automatically, please click the button below to view PDF in a separate window.
                            </Card.Text>
                            <Button 
                              variant="success"
                              className="shadow-lg"
                              size="sm"
                              href={props.frameContent}
                              target="_blank"
                              // onLoad={openInNewTab}
                            >View PDF File</Button>
                          </Card.Body>
                        </Card>
                      )
                    }
                    </>
                    </>
                  }
          </Row> 
        </Container>
      );
    }
  };


  return (
    <Container>
      <Row>
        <Col className="sm-9">{setHeight()}</Col>
      </Row>
    </Container>
  );
};

export default MyFrame;


